import React, { useState } from 'react';
import Text from '../components/elements/TextComponent';
import InputField from '../components/elements/InputField';
import TextWithButton from '../components/elements/TextWithButtonComponent';
import Button from '../components/elements/Button';
import userAtDesk from '../assets/userAtDesk.svg';
import ImageComponent from '../components/elements/ImageComponent';
import { loginUser } from '../api/userApi';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

interface Props {}

const Login: React.FC<Props> = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleLogin = async () => {
    const result = await loginUser({ email, password });
    if (result.error) {
      setStatus('error');
      setMessage('Incorrect Email or Password');
    } else {
      navigate('/dashboard');
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20, scale: 0.98 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, y: -20, scale: 0.98 }}
      transition={{ duration: 0.35, ease: 'easeInOut' }}
    >
      <div className="split-screen">
        {/* Left side */}
        <div className="left-side color-purple-background">
          <div className="margin-top-20p" style={{ width: '50vw', height: '100vh' }}>
            <ImageComponent src={userAtDesk} center />
            <Text
              text="ComeChatWithMe.ai"
              fontSize="32px"
              fontWeight="700"
              lineHeight="38px"
              color="#ffffff"
              textAlign="center"
              navigateToHome
            />
            <div className="margin-top-30">
              <Text
                text="Create and share personalized assistants effortlessly."
                fontSize="18px"
                fontWeight="400"
                lineHeight="18px"
                color="#ffffff"
                textAlign="center"
              />
            </div>
          </div>
        </div>

        {/* Right side */}
        <div className="right-side">
          <div className="margin-top-64 margin-right-64">
            <Text
              text="ComeChatWithMe.ai"
              fontSize="32px"
              fontWeight="700"
              lineHeight="38px"
              color="#030303"
              textAlign="right"
              navigateToHome
            />
            <Text
              text="Resume"
              fontSize="16px"
              fontWeight="400"
              lineHeight="18px"
              color="#030303"
              textAlign="right"
            />
          </div>
          <div className="margin-top-192 margin-left-20p">
            <Text
              text="Log in"
              fontSize="32px"
              fontWeight="700"
              lineHeight="38px"
              color="#030303"
              textAlign="left"
            />
            <div className="margin-top-20 margin-bottom-20">
              <TextWithButton
                text="Login or "
                fontSize="16px"
                fontWeight="400"
                lineHeight="18px"
                color="#030303"
                textAlign="left"
                showButton
                buttonLabel="register"
                onButtonClick={() => navigate('/register')}
              />
            </div>
            <InputField
              text="Enter your email"
              fontSize="16px"
              fontWeight={500}
              onChange={(e) => setEmail(e.target.value)}
            />
            <div className="margin-top-20 margin-bottom-20">
              <Text
                text="Password"
                fontSize="16px"
                fontWeight="400"
                lineHeight="18px"
                color="#030303"
                textAlign="left"
              />
            </div>
            <InputField
              text=""
              fontSize="16px"
              fontWeight={500}
              type="password"
              onChange={(e) => setPassword(e.target.value)}
            />
            <div style={{ marginTop: 8, marginBottom: 20 }}>
            <a
              href="/forgot-password"
              style={{
                color: 'var(--primary)',
                fontFamily: 'Montserrat',
                fontSize: '14px',
                textDecoration: 'underline',
              }}
            >
              Forgot your password?
            </a>
          </div>
            <div className="margin-top-30 margin-bottom-20">
              <Button
                backgroundColor="var(--primary)"
                color="#ffffff"
                label="Log in"
                onClick={handleLogin}
              />
            </div>
            {status !== 'idle' && (
            <p
                style={{
                fontFamily: 'Montserrat',
                fontSize: '14px',
                marginTop: '20px',
                color: status === 'success' ? '#2e7d32' : '#d32f2f',
                textAlign: 'left',
                }}
            >
                {message}
            </p>
            )}

            {/* Links */}
            <div className="margin-top-20" style={{ fontSize: 14 }}>
              <a href="/termsofservice"style={{ 
                color: 'var(--primary)', 
                fontFamily: 'Montserrat', 
                fontSize: '14px', 
                textDecoration: 'underline',
                marginRight: 12 
                }}>
                Terms of Service
              </a>
              <a href="/privacypolicy" style={{ 
                color: 'var(--primary)', 
                fontFamily: 'Montserrat', 
                fontSize: '14px', 
                textDecoration: 'underline',
                marginRight: 12 
                }}>
                Privacy Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default Login;
